import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { firestore } from '../../config/firebase';
import { fetchInventorys } from '../../store/actions/inventoryActions';
import Spinner from '../UIComponents/Spinner';
import lang from './lang';
import './InventoryCount.css';

class InventoryCount extends Component {
    state = { data: [], display: 'none' }

    componentDidMount() {
        this.setState({ data: this.props.inventory });

        firestore.collection('users')
            .doc(this.props.user.id)
            .collection('inventory')
            .onSnapshot((docs) => {
                if (docs.size !== this.props.inventory.length) {
                    let data = docs.docs.map(item => ({ ...item.data(), id: item.id }));
                    this.setState({ data, display: 'none' });
                    this.props.fetchInventorys(data);
                } else {
                    this.setState({ display: 'none' });
                }

            });
    }

    render() {
        const { title, date, total, missing, extra, newBtn } = lang[this.props.user.lang || 'uz']
        return (
            <div id="inventory-count-page">
                <Spinner display={this.state.display} />
                <div className="mb-3 text-right">
                    <Link to="/inventory-count/new" className="btn btn-outline-success rounded-pill px-4">+ {newBtn}</Link>
                </div>
                <h3 className="text-center my-3">{title}</h3>
                <table className="table table-striped table-lg table-bordered text-center table-responsive-sm">
                    <thead className="thead-dark">
                        <tr>
                            <th>#</th>
                            <th>{date}</th>
                            <th>{total}</th>
                            <th>{missing}</th>
                            <th>{extra}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.data.map((item, i) => {
                                return (
                                    <tr key={item.id} ref={ref => this[item.id + 'Ref'] = ref}>
                                        <td>{i + 1}</td>
                                        <td>{new Date(item.updatedAt).toLocaleString()}</td>
                                        <td>{item.totalItems}</td>
                                        <td className={`${item.missingItems > 0 ? 'text-danger' : ''}`}>{item.missingItems}</td>
                                        <td className={`${item.extraItems > 0 ? 'text-warning' : ''}`}>{item.extraItems}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        products: state.products,
        user: state.user,
        inventory: state.inventorys.inventorys
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchInventorys: (data) => dispatch(fetchInventorys(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryCount);